<template>
  <div id="app">
    <header style="width: 100%; position: fixed;z-index: 9999;">
      <b-navbar
        toggleable="lg"
        variant="light"
        class="shadow-sm px-3 main-nav"
        id="mainNavbar"
      >
        <div class="container-fluid px-3">
          <b-navbar-brand href="/">
            <img class="logo_img" src="@/assets/new/logo.png" alt="" />
          </b-navbar-brand>

          <b-navbar-toggle target="navWrap" id="toggleBtn"></b-navbar-toggle>

          <b-collapse id="navWrap" is-nav>
            <b-navbar-nav class="mx-auto align-items-start align-items-lg-center">
              <!-- 首页 -->
              <b-nav-item
                href="/"
                class="py-2 py-lg-0"
                @click="bindclick($event, '1')"
                :class="{ active: activeIndex === '1' }"
              >
                首页
              </b-nav-item>

              <!-- 店收盈 -->
              <b-nav-item-dropdown
                text="店收盈"
                class="py-2 py-lg-0"
                :class="{ active: ['2-1','2-2','2-3','2-4','2-5','2-6','2-7'].includes(activeIndex) }"
              >
                <b-dropdown-item @click="bindclick($event, '2-1')">店收盈APP</b-dropdown-item>
                <b-dropdown-item @click="bindclick($event, '2-2')">店收盈码牌</b-dropdown-item>
                <b-dropdown-item @click="bindclick($event, '2-3')">店收盈云音箱</b-dropdown-item>
                <b-dropdown-item @click="bindclick($event, '2-4')">客显屏音箱</b-dropdown-item>
                <b-dropdown-item @click="bindclick($event, '2-5')">扫码盒</b-dropdown-item>
                <b-dropdown-item @click="bindclick($event, '2-6')">智能POS</b-dropdown-item>
                <b-dropdown-item @click="bindclick($event, '2-7')">定制云打印机</b-dropdown-item>
              </b-nav-item-dropdown>

              <!-- 合作案例 -->
              <b-nav-item
                href="/news"
                class="py-2 py-lg-0"
                @click="bindclick($event, '3')"
                :class="{ active: activeIndex === '3' }"
              >
                合作案例
              </b-nav-item>

              <!-- 关于我们 -->
              <b-nav-item-dropdown
                text="关于我们"
                class="py-2 py-lg-0"
                :class="{ active: ['4-1','4-2','4-3','4-4'].includes(activeIndex) }"
              >
                <b-dropdown-item @click="bindclick($event, '4-1')">企业简介</b-dropdown-item>
                <b-dropdown-item @click="bindclick($event, '4-2')">创始人</b-dropdown-item>
                <b-dropdown-item @click="bindclick($event, '4-3')">新闻动态</b-dropdown-item>
                <b-dropdown-item @click="bindclick($event, '4-4')">集团架构</b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>

            <div class="right-box d-flex align-items-center flex-nowrap">
              <span class="phone_box">
                <i class="el-icon-phone-outline"></i>
                <span style="margin-left: 6px">400-060-8899</span>
              </span>
              <b-button
                variant="primary"
                size="sm"
                class="d-none d-lg-block ms-3 el-button"
                style="margin-left: 20px"
                @click="goLogin"
              >
                登录
              </b-button>
            </div>
          </b-collapse>
        </div>
      </b-navbar>
    </header>

    <div class="container" style="clear: both">
      <router-view></router-view>
    </div>

    <div class="footer">
      <div class="container">
        <div class="foot-content">
          <div class="foot-left">
            <div class="foot-logo">
              <img src="@/assets/new/logo.png" alt="" />
            </div>
            <div class="foot-company">
              <span>版权：</span>
              <span>福建聚合云科技集团有限公司</span>
            </div>
            <div class="foot-phone">TEL：400-060-8899</div>

            <div class="foot-code">
              <div class="foot-content-top-right-item">
                <img src="@/assets/new/juheyun.png" alt="" />
                <div class="foot-content-top-right-item-title">聚合云集团</div>
              </div>
              <div class="foot-content-top-right-item">
                <img src="@/assets/new/dianshouying.png" alt="" />
                <div class="foot-content-top-right-item-title">店收盈</div>
              </div>
              <div class="foot-content-top-right-item">
                <img src="@/assets/new/shipinhao.png" alt="" />
                <div class="foot-content-top-right-item-title">视频号</div>
              </div>
            </div>

            <div class="foot-address">
              <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35011102350981">闽公网安备 35011102350981号</a>
              <a href="https://beian.miit.gov.cn/#/Integrated/index">闽ICP备2023012414号-1</a>
            </div>
          </div>

          <div class="foot-right">
            <div class="foot-content-item">
              <div class="foot-title">关于我们</div>
              <div class="foot-name" @click="handleSelect('4-1')">公司介绍</div>
              <div class="foot-name" @click="handleSelect('4-2')">创始人</div>
              <div class="foot-name" @click="handleSelect('4-3')">新闻动态</div>
            </div>

            <div class="foot-content-item">
              <div class="foot-title">合作案例</div>
              <div class="foot-name" @click="handleSelect('3')">餐饮行业解决方案</div>
            </div>

            <div class="foot-content-item">
              <div class="foot-title">产品服务</div>
              <div class="foot-name" @click="handleSelect('2-1')">店收盈APP</div>
              <div class="foot-name" @click="handleSelect('2-2')">店收盈码牌</div>
              <div class="foot-name" @click="handleSelect('2-3')">店收盈云音箱</div>
              <div class="foot-name" @click="handleSelect('2-4')">客显屏音箱</div>
              <div class="foot-name" @click="handleSelect('2-5')">扫码盒</div>
              <div class="foot-name" @click="handleSelect('2-6')">智能POS</div>
              <div class="foot-name" @click="handleSelect('2-7')">定制云打印机</div>
            </div>

            <div class="foot-content-item">
              <div class="foot-title">技术支持</div>
              <div class="foot-name">帮助中心</div>
              <div class="foot-name">SDK接入</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Layout",
  data() {
    return {
      activeIndex: localStorage.getItem("activeIndex") || "1",
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        const path = this.$route.path;
        const routeMap = {
          "/": "1",
          "/storeEarnings": "2-1",
          "/storeTag": "2-2",
          "/loudspeakerBox": "2-3",
          "/guestDisplay": "2-4",
          "/scanBox": "2-5",
          "/smartPOS": "2-6",
          "/customization": "2-7",
          "/cooperation": "3",
          "/companyProfile": "4-1",
          "/originator": "4-2",
          "/newsList": "4-3",
          "/frameWork": "4-4",
        };
        this.activeIndex = routeMap[path] || "1";
        localStorage.setItem("activeIndex", this.activeIndex);
      },
    },
  },
  methods: {
    goLogin() {
      window.location.href = "https://mer.jhypay.com/login";
    },
    handleSelect(key) {
      const activeIndex = key.split("-")[0];
      this.activeIndex = key;
      localStorage.setItem("activeIndex", key);

      switch (key) {
        case "1": this.$router.push({ name: "Index" }); break;
        case "2-1": this.$router.push({ name: "StoreEarnings" }); break;
        case "2-2": this.$router.push({ name: "StoreTag" }); break;
        case "2-3": this.$router.push({ name: "LoudspeakerBox" }); break;
        case "2-4": this.$router.push({ name: "GuestDisplay" }); break;
        case "2-5": this.$router.push({ name: "ScanBox" }); break;
        case "2-6": this.$router.push({ name: "SmartPOS" }); break;
        case "2-7": this.$router.push({ name: "Customization" }); break;
        case "3": this.$router.push({ name: "Cooperation" }); break;
        case "4-1": this.$router.push({ name: "CompanyProfile" }); break;
        case "4-2": this.$router.push({ name: "Originator" }); break;
        case "4-3": this.$router.push({ name: "NewsList" }); break;
        case "4-4": this.$router.push({ name: "FrameWork" }); break;
      }
      this.backTop();
    },
    backTop() {
      let that = this;
      cancelAnimationFrame(that.timer);
      that.timer = requestAnimationFrame(function fn() {
        var oTop = document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop = oTop - 50;
          that.timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(that.timer);
        }
      });
    },
    bindclick(e, index) {
      e.preventDefault();
      this.handleSelect(index);
    },
  },
  mounted() {
    this.backTop();
  },
};
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
}

::v-deep #mainNavbar {
  background-color: #de1f26 !important;
}

.main-nav {
  padding-left: 24px !important;
  padding-right: 24px !important;
}

@media (max-width: 991px) {
  .main-nav {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
}

.logo_img {
  height: 40px;
  max-width: 160px;
  width: auto;
  object-fit: contain;
  display: block;
}

@media (max-width: 991px) {
  .logo_img {
    height: 36px;
    max-width: 140px;
  }
  .nav-item{
    width: 100%;
    text-align: center;
  }
}

::v-deep #mainNavbar .nav-link {
  color: rgba(255, 255, 255, 0.6) !important;
  padding: 0 36px;
  white-space: nowrap;
}

/* 导航高亮 */
::v-deep #mainNavbar .nav-item.active .nav-link {
  width: 100%;
  text-align: center;
  color: #ffffff !important;
  font-weight: 600 !important;
}

@media (max-width: 991px) {
  ::v-deep #mainNavbar .nav-link {
    padding: 5px 0;
    font-size: 22px;
    color: #fff !important;
  }

  /* 关键：折叠后导航居中 */
  ::v-deep .navbar-nav {
    justify-content: center !important;
  }

  ::v-deep .dropdown-menu {
    text-align: center !important;
    width: 100% !important;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  ::v-deep .dropdown-item {
    color: rgba(255, 255, 255, 0.9) !important;
    font-size: 20px;
  }
}

::v-deep #toggleBtn .navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255,255,255,1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
}

::v-deep #toggleBtn {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

::v-deep #mainNavbar .nav-link:hover {
  color: #ffebee !important;
}

.right-box {
  width: 100%;
  justify-content: center;
  margin-top: 10px;
}

@media (min-width: 992px) {
  .right-box {
    width: auto;
    justify-content: flex-end;
    margin-top: 0;
  }
}

.phone_box {
  display: flex;
  color: #fff;
  align-content: center;
  border: 1px solid #fff;
  border-radius: 30px;
  padding: 4px 12px;

  .el-icon-phone-outline {
    font-size: 20px;
    margin-top: 2px;
    margin-right: 6px;
  }
}

.el-button {
  width: 80px;
  height: 36px;
  background-color: #fff;
  color: #de1f26;
  border: none;
  margin-left: 20px;
}

.container {
  padding-top: 65px;
  max-width: 100% !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
}

/* ========== footer ========== */
.footer {
  width: 100%;
  background-color: #17181c;
  color: #999;
  padding: 40px 0;
  font-size: 14px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.foot-content {
  display: flex;
  flex-wrap: wrap;

  a {
    color: #999;
    text-decoration: none;
  }
}

.foot-left {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin-bottom: 30px;

  .foot-logo {
    height: 50px;

    img {
      height: 50px;
    }
  }

  .foot-company {
    margin-top: 20px;
    line-height: 1.5;
  }

  .foot-phone {
    margin-top: 15px;
  }

  .foot-code {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-top: 20px;

    .foot-content-top-right-item {
      text-align: center;

      img {
        width: 80px;
        height: 80px;
      }

      .foot-content-top-right-item-title {
        margin-top: 5px;
        font-size: 12px;
        color: #ccc;
      }
    }
  }

  .foot-address {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
}

@media (max-width: 767px) {
  .foot-right {
    display: none !important;
  }
}

.foot-right {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;

  .foot-content-item {
    min-width: 120px;

    .foot-title {
      color: #fff;
      font-size: 16px;
      margin-bottom: 15px;
    }

    .foot-name {
      margin-top: 10px;
      cursor: pointer;

      &:hover {
        color: #fff;
      }
    }
  }
}

@media (min-width: 768px) {
  .foot-content {
    flex-wrap: nowrap;
  }

  .foot-left {
    width: 40%;
    margin-bottom: 0;
  }

  .foot-right {
    width: 60%;
    justify-content: space-between;
    gap: 0;
  }

  .foot-address {
    flex-direction: row;
    gap: 20px;
  }
}
</style>
